import { render } from "./nonacademicAssessorSection3.vue?vue&type=template&id=7c6baa4a"
import script from "./nonacademicAssessorSection3.vue?vue&type=script&lang=js"
export * from "./nonacademicAssessorSection3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__